import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import {
    Typography,
    Container,
    Dialog,
    Grid,
    TextField,
    RadioGroup,
    Radio,
    FormControlLabel,
} from "@material-ui/core";
import { CommonStyles } from "../../commons/CommonStyles";
import { DialogStyles } from "../CommonComponents/Dialogs/DialogStyles";
import { checkIsNullUndefined, decode64, encode64, getErrorMessage } from "../../commons/Utils";
import {
    PostProfileUserOnlyEmail,
    PostVerificationSendEmail,
    PostVerificationDataEmail,
} from "../../services/ReasonService";
import { useTranslation } from "react-i18next";
import { CorreosButton } from "../CorreosButton/CorreosButton";
import { PostApplicationAuxSSOLogin } from "../../services/ApplicationAuxCallsService";
import { Constants } from "../../commons/Constants";
import { backToLogin, removeUserSession, setUserSession } from "../../services/Commons";

export function DialogOneEmail(props) {
    const { open, auxUser, setAuxUser, userEmails, userPhones, setOpenOnePhone, tokenResult, setTokenResult, finishOperation, managePath } = props;
    const commonClasses = CommonStyles();
    const dialogClasses = DialogStyles();
    const cookies = new Cookies();
    const { t, i18n } = useTranslation();

    const [emailOriginalList, setEmailOriginalList] = useState([]);
    const [emailList, setEmailList] = useState([]);
    const [email, setEmail] = useState("");
    const [sending, setSending] = useState(false);
    const [working, setWorking] = useState(false);
    const [sended, setSended] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState(false);
    const [otpErrorText, setOtpErrorText] = useState("");
    const [notVerified, setNotVerified] = useState(false);

    useEffect(() => {
        setEmailOriginalList(JSON.parse(JSON.stringify(userEmails)));
        let auxList = userEmails.map(email => email.email);
        setEmailList(auxList);
        let auxValue = auxList.find(email => email === auxUser);
        let defaultEmail = checkIsNullUndefined(auxValue) ? auxList[0] : auxValue;
        setEmail(defaultEmail);
    }, [open, userEmails, auxUser]);

    const handleChangeOtp = (value) => {
        const re = /^[0-9\b]{1,12}$/;
        if (value === "" || re.test(value)) {
            setOtp(value);
        };
    };

    const handleChangeEmail = (value) => {
        let auxVerif = false;
        let auxEmail = emailOriginalList.find(emails => emails.email === value);
        if (auxEmail.idConTypeVerification < 2) {
            auxVerif = true;
        };
        setNotVerified(auxVerif);
        setEmail(value);
    };

    const mountForm = () => {
        return (
            <Grid item xs={12}>
                <Typography>
                    <strong>{t("loginSelectOneEmailSelect")}</strong>
                </Typography>
                <RadioGroup
                    defaultValue={email}
                    value={email}
                    onChange={(e) => handleChangeEmail(e.target.value)} style={{ marginLeft: "1em", }} >

                    {emailList.map((auxEmail) => {
                        return (
                            <FormControlLabel key={auxEmail} value={auxEmail} control={<Radio />} label={auxEmail} style={{ marginBottom: "-0.5em" }} />
                        )

                    })}
                </RadioGroup>
            </Grid>
        );
    };

    const checkDisabledConfirm = () => {
        return (notVerified && !sended) && (checkIsNullUndefined(otp) || otpError || sending);
    };

    const handleConfirm = () => {
        setWorking(true);
        if (notVerified) {
            handleVerifyOtp();
        } else {
            handleDeleteEmails();
        };
    };

    const handleDeleteEmails = async () => {
        await PostProfileUserOnlyEmail(email);
        checkLastStep();
    };

    const handleSendOtp = async () => {
        setSending(true);
        let auxError = false;
        let auxErrorText = "";
        let auxSended = false;
        let response = await PostVerificationSendEmail(email);
        if (response && !response.Status) {
            auxSended = true;
        } else {
            auxError = true;
            auxErrorText = getErrorMessage(response);
        };
        setOtpError(auxError);
        setOtpErrorText(auxErrorText);
        setSending(false);
        setSended(auxSended);
    };

    const handleVerifyOtp = async () => {
        let response = await PostVerificationDataEmail(email, otp);
        if (response && !response.Status) {
            handleDeleteEmails();
        } else {
            finishOperation("error", getErrorMessage(response));
            setWorking(false);
        };
    };

    const checkLastStep = async () => {
        if (email != auxUser) {
            let sessionCookie = cookies.get(Constants.cookieValue);
            let auxCookie = decode64(sessionCookie);
            let encodedCookie = encode64(auxCookie.IdCookie);
            let response = await PostApplicationAuxSSOLogin(encodedCookie);
            if (response && (!response.Status || response.Status < 400)) {
                removeUserSession().then(() => {
                    setUserSession(response, i18n, null).then(() => {
                        setAuxUser(email);
                        checkHasMoreThanOnePhone(response);
                    });
                });
            } else {
                finishOperation("error", getErrorMessage(response));
                backToLogin();
            };
        } else {
            checkHasMoreThanOnePhone(tokenResult);
        };
    };

    const checkHasMoreThanOnePhone = (auxToken) => {
        if (userPhones && userPhones.length > 1) {
            setTokenResult(auxToken);
            setOpenOnePhone(true);
        } else {
            managePath(auxToken, email);
        };
    };

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            PaperProps={{ classes: { root: dialogClasses.dialogWindow } }}
        >
            <>
                <Container className={dialogClasses.dialogTitle}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h4" className={dialogClasses.dialogTitleText}>
                                {t("loginSelectOneEmailTitle")}
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
                <Container className={dialogClasses.dialogContainer}>
                    <Grid container item xs={12} className={commonClasses.gridIdentity}>
                        <Grid item xs={12} style={{ marginBottom: "1em" }}>
                            <Typography className={commonClasses.dialogContentText}>
                                {t("loginSelectOneEmailText")}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={1}>
                        {mountForm()}
                        {notVerified && (
                            <Grid container item xs={12} className={commonClasses.gridIdentity}>
                                <Grid item xs={12} style={{ marginBottom: "1em" }}>
                                    <Typography className={commonClasses.dialogContentText}>
                                        {t("loginSelectOneEmailNotVerified")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <TextField
                                        color="secondary"
                                        defaultValue={otp}
                                        value={otp}
                                        onChange={(value) => handleChangeOtp(value.target.value)}
                                        variant="filled"
                                        fullWidth
                                        name="otp"
                                        autoFocus
                                        label={t("login2FASetPhoneOtp")}
                                        type="text"
                                        error={otpError}
                                        helperText={otpErrorText}
                                        required
                                        className={commonClasses.inputsStyle}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <CorreosButton
                                        color={sended ? "secondary" : "primary"}
                                        variant={sended ? "outlined" : "contained"}
                                        onClick={() => handleSendOtp()}
                                        disabled={working}
                                        circularProgress={sending}
                                    >
                                        {sended ? t("reSend") : t("send")}
                                    </CorreosButton>
                                </Grid>
                            </Grid>

                        )}
                        <Grid
                            item
                            container
                            xs={12}
                            className={dialogClasses.dialogButtonContainer}
                        >
                            <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
                                <CorreosButton
                                    variant="contained"
                                    color="primary"
                                    onClick={handleConfirm}
                                    className={dialogClasses.dialogButtonCenter}
                                    disabled={checkDisabledConfirm()}
                                    circularProgress={working}
                                >
                                    {t("confirm")}
                                </CorreosButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </>
        </Dialog>
    );
}
